import { render } from "./FaqModal.vue?vue&type=template&id=2b8685be&scoped=true"
import script from "./FaqModal.vue?vue&type=script&lang=js"
export * from "./FaqModal.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2b8685be"

export default script